import { PayloadAction } from '@reduxjs/toolkit'
import { IVoiceCatalogState } from 'store/types/voiceCatalog'
import {
  ITtsLanguageOption,
  ITtsSpeaker,
  ITtsSpeakerTone
} from 'types/text-to-speech'

const reducers = {
  setLanguageOptions: (
    state: IVoiceCatalogState,
    action: PayloadAction<ITtsLanguageOption[]>
  ) => {
    state.languageOptions = {
      data: action.payload,
      isLoading: false
    }
  },
  setLanguageOptionsIsLoading: (
    state: IVoiceCatalogState,
    action: PayloadAction<boolean>
  ) => {
    state.languageOptions.isLoading = action.payload
  },
  setAvatarLanguageOptions: (
    state: IVoiceCatalogState,
    action: PayloadAction<ITtsLanguageOption[]>
  ) => {
    state.avatarLanguageOptions = {
      data: action.payload,
      isLoading: false
    }
  },
  setAvatarLanguageOptionsIsLoading: (
    state: IVoiceCatalogState,
    action: PayloadAction<boolean>
  ) => {
    state.avatarLanguageOptions.isLoading = action.payload
  },
  setSpeakersPerLangCode: (
    state: IVoiceCatalogState,
    action: PayloadAction<{ langCode: string; speakers: ITtsSpeaker[] }>
  ) => {
    const { langCode, speakers } = action.payload
    state.speakersPerLangCode = {
      ...state.speakersPerLangCode,
      [langCode]: {
        data: speakers,
        isLoading: false
      }
    }
  },
  setSpeakersPerLangCodeIsLoading: (
    state: IVoiceCatalogState,
    action: PayloadAction<{ langCode: string; isLoading: boolean }>
  ) => {
    const { langCode, isLoading } = action.payload
    if (!state.speakersPerLangCode) {
      state.speakersPerLangCode = {}
    }
    state.speakersPerLangCode[langCode] = {
      ...state.speakersPerLangCode[langCode],
      isLoading
    }
  },
  setSpeakerTones: (
    state: IVoiceCatalogState,
    action: PayloadAction<ITtsSpeakerTone[]>
  ) => {
    state.speakerTones = {
      data: action.payload,
      isLoading: false
    }
  },
  setSpeakerTonesIsLoading: (
    state: IVoiceCatalogState,
    action: PayloadAction<boolean>
  ) => {
    state.speakerTones.isLoading = action.payload
  }
}

export default reducers
